import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/arrow.png'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("th", { scope: "row" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "arrow",
    width: "27",
    src: _imports_0
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.renderComponent)
    ? (_openBlock(), _createElementBlock("tr", _hoisted_1, [
        _hoisted_2,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.objectTemplates, (_objectTemplate, key, index) => {
          return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getComponent(_objectTemplate.Region, _objectTemplate.ObjectEnum)), {
            key: `${ key }-${ index }-${ Math.random().toString(36).slice(2, 7) }`,
            entity: _ctx.resolveEntities(_objectTemplate),
            object: _objectTemplate
          }, null, 8, ["entity", "object"]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}